import { Modal, Form, Spin, ConfigProvider } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDom from "react-dom";
import Events from "../@utils/events";
import { Provider } from "react-redux";
import store from "../@store";
import "moment/locale/zh-cn";
import zhCN from "antd/lib/locale/zh_CN";

/**
 *
 * @param Component 表单组件
 * @returns { open } 打开modal
 * @returns { close } 关闭modal
 */
export default function useModalForm(Component) {
  const MountDom = useRef(document.createElement("div", { id: Math.random() }));
  const events = useRef(new Events());
  useEffect(() => {
    let _MountDom = MountDom.current;
    document.body.appendChild(_MountDom);
    return () => {
      document.body.removeChild(_MountDom);
    };
  }, []);

  useEffect(() => {
    let _MountDom = MountDom.current;
    ReactDom.unmountComponentAtNode(_MountDom);
    ReactDom.render(
      <FormModel events={events.current} formComponent={Component} />,
      _MountDom
    );
    return () => {
      ReactDom.unmountComponentAtNode(_MountDom);
    };
  }, [Component]);
  /**
   *
   * @param {点击确定时执行的方法} _onOk
   * @param {初始化表单Object or Function or AsyncFunction} defaultFormValue
   * @param {modal组件props} modalProps
   */
  const open = (_onOk, defaultFormValue, modalProps) => {
    events.current.emit("open", {
      _onOk,
      defaultFormValue,
      modalProps,
    });
  };

  const close = () => {
    events.current.emit("close");
  };
  return {
    open,
    close,
  };
}

const FormModel = (props) => {
  const [$confirmLoading, set$confirmLoading] = useState(false);
  const [$show, set$show] = useState(false);
  const ref$onOk = useRef();
  const [$modalProps, set$modalProps] = useState({});
  const [$onInit, set$onInit] = useState(false);
  const [form] = Form.useForm();

  const close = useCallback(() => {
    set$confirmLoading(false);
    set$show(false);
    form.resetFields();
  }, [form]);
  const open = useCallback(
    async ({ _onOk, defaultFormValue, modalProps }) => {
      ref$onOk.current = async () => {
        if (_onOk) {
          await form.validateFields();
          set$confirmLoading(true);
          try {
            await _onOk(form.getFieldsValue(), form);
            set$confirmLoading(false);
            close();
          } catch (e) {
            set$confirmLoading(false);
          }
        } else {
          close();
        }
      };
      set$modalProps(modalProps);
      set$show(true);
      if (typeof defaultFormValue === "object") {
        form.setFieldsValue(defaultFormValue);
      } else if (typeof defaultFormValue === "function") {
        set$onInit(true);
        form.setFieldsValue(await defaultFormValue());
        set$onInit(false);
      }
    },
    [form, close]
  );

  useEffect(() => {
    const offOpen = props.events.on("open", (_onOk) => {
      open(_onOk);
    });
    const offClose = props.events.on("close", () => {
      close();
    });
    return () => {
      offOpen();
      offClose();
    };
  }, [props.events, open, close]);
  return (
    <ConfigProvider locale={zhCN}>
      <Modal
        visible={$show}
        onCancel={close}
        confirmLoading={$confirmLoading}
        onOk={() => {
          if (ref$onOk.current) ref$onOk.current();
        }}
        {...$modalProps}
      >
        {$onInit ? (
          <div
            style={{
              height: "200px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Provider store={store}>
            {React.createElement(props.formComponent, {
              originForm: form,
            })}
          </Provider>
        )}
      </Modal>
    </ConfigProvider>
  );
};
